import React from "react";
import { useSelector } from "react-redux";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { organizationalToolsFilters, addedByEduToolsFilters } from "../../../../shared/utils/entitiesFiltersUtils";
import { mapToolsForDisplay } from "../../../../shared/utils/toolDisplayUtils";
import Popup from "../../../../shared/components/ui/popup/Popup";
import HeaderPopup from "../../../../shared/components/ui/popup/headerPopup/HeaderPopup";
import ContentPopup from "../../../../shared/components/ui/popup/contentPopup/ContentPopup";
import ToolsList from "../../../../shared/components/features/toolsList/ToolsList";
import classes from "./ViewAllToolsPopup.module.css";

const ViewAllToolsPopup = ({ onClose }) => {
    const { lang, texts } = useSelector(state => state.translate);

    const organizationalToolsRaw = useSelector(state => selectEntitiesByFilters(state, organizationalToolsFilters));
    const addedByEduToolsRaw = useSelector(state => selectEntitiesByFilters(state, addedByEduToolsFilters));

    const organizationalTools = mapToolsForDisplay(organizationalToolsRaw, lang);
    const addedByEduTools = mapToolsForDisplay(addedByEduToolsRaw, lang);

    return (
        <Popup close={onClose} accessibilityDescription={texts.additionalSystemTools} dropClass={classes.PopupDrop}>
            <HeaderPopup className={classes.HeaderPopup} accessibilityDescription={texts.additionalSystemTools}>
                <p className={classes.HeaderTitle}>{texts.additionalSystemTools}</p>
            </HeaderPopup>
            <ContentPopup className={classes.Body}>
                <div className={classes.Section}>
                    <ToolsList text={texts.organizationalTools} tools={organizationalTools} />
                </div>
                <div className={classes.Section}>
                    <ToolsList text={texts.ministryOfEducationTools} tools={addedByEduTools} className={classes.ToolsListMinistryOfEducation}/>
                </div>
            </ContentPopup>
        </Popup>
    );
};

export default ViewAllToolsPopup;
